<template>
	<div>
		<v-overlay :value="isReloadingPratiche || updatingPraticaObject || updatingPraticaTags || updatingContrattoDiServizioTags">
			<v-progress-circular
				indeterminate
				size="64"
				color="primary"
			></v-progress-circular>
		</v-overlay>

		<v-data-table
			:headers="headersToShow"
			:items="pratiche"
			:search="search"
			:loading="isLoading"
			class="tour-step-9"
			:footer-props="{
			'items-per-page-options': [5, 10, 25, 50, 100]
		}"
			:items-per-page="25"
			sort-by="updated_at"
			sort-desc
			:height="dataTableHeight"
			fixed-header
			multi-sort
		>
			<!-- ITEMS -->
			<!--<template v-slot:item.accordo.account_manager="{ item }">-->
			<!--	{{ item.accordo.account_manager.nome }} {{ item.accordo.account_manager.cognome }}-->
			<!--</template>-->
			<template v-slot:item.stato_fasi_pratica="{ item, index }">
				<div class="mt-2 mb-1">
					<anteprima-stato-fasi
						:class="index == 0 ? 'tour-step-13 tour-step-14' : ''"
						:aggiornamenti="calcolaAggiornamentiAnteprimaStatoFasiPratica(item)"
						:ci_sono_aggiornamenti_per_account_manager_fase_1="item.ci_sono_aggiornamenti_per_account_manager_fase_1"
						@open-pratica-tab-anteprima-stato-fasi="openPraticaDialog('edit', item, $event)"
					></anteprima-stato-fasi>

					<!--rimossi dal componente anteprima-stato-fasi dopo il refactoring-->
					<!--:contratto-di-servizio-id="contrattoDiServizioId"-->
					<!--@reload-pratiche="reloadPratiche()"-->
					<!--@reload-accordi="$emit('reload-accordi')"-->
					<!--@reload-contratti-di-servizio="$emit('reload-contratti-di-servizio')"-->
					<!--@aggiornamenti-visualizzati="setAggiornamentiVisualizzati($event)"-->
					<!--:pratica="praticaPerAnteprimaStatoFasi(item)"-->
					<!--:fasi-with-stati="fasiWithStati"-->
				</div>
			</template>

			<template v-slot:item.agevolazione_richiesta_senza_casting="{ item }">
				{{ item.agevolazione_richiesta }}
			</template>

			<template v-slot:item.partita_iva_codice_fiscale_univoco="{ item }">
				{{ item.partita_iva_codice_fiscale_univoco ? 'SI' : 'NO' }}
			</template>

			<template v-slot:item.importo_da_fatturare="{ item }">
				{{ item.importo_da_fatturare?.replace('.', ',') }}
			</template>

			<template v-slot:item.posizione_classifica_a_tempo="{ item }">
				{{ item.posizione_classifica_a_tempo }}
			</template>

			<template v-slot:item.importo_da_fatturare_esiti_definitivi="{ item }">
				{{ item.importo_da_fatturare_esiti_definitivi?.replace('.', ',') }}
			</template>

			<template v-slot:item.importo_bonus_esiti_provvisori="{ item }">
				{{ item.importo_bonus_esiti_provvisori?.replace('.', ',') }}
			</template>

			<template v-slot:item.importo_bonus_esiti_definitivi="{ item }">
				{{ item.importo_bonus_esiti_definitivi?.replace('.', ',') }}
			</template>

			<template v-slot:item.created_at="{ item }">
				{{ getDateFromDateTime(item.created_at) }}
			</template>

			<template v-slot:item.updated_at="{ item }">
				{{ formatDateTimeToItaly(item.updated_at) }}
			</template>

			<template v-slot:item.one_string_tags="{ item }">
				<span
					style="cursor: pointer"
					@click="openTagsDialog(item)"
				>
					{{ item.one_string_tags }}
				</span>
			</template>

			<template v-slot:item.contratto_di_servizio.one_string_tags="{ item }">
				<span
					style="cursor: pointer"
					@click="openContrattoDiServizioTagsDialog(item.contratto_di_servizio)"
				>
					{{ item.contratto_di_servizio === null ? '' : (item.contratto_di_servizio.one_string_tags || '------') }}
				</span>
			</template>

			<template v-slot:item.notes="{ item }">
				<span
					class="d-inline-block text-truncate"
					style="max-width: 150px; cursor: pointer"
					@click="openPraticaNotesDialog(item)"
				>
					{{ item.notes || '------' }}
				</span>
			</template>

			<template v-slot:item.accordo.notes="{ item }">
				<span
					class="d-inline-block text-truncate"
					style="max-width: 150px; cursor: pointer"
					@click="openAccordoNotesDialog(item)"
				>
					{{ item.accordo.notes || '------' }}
				</span>
			</template>

			<template v-slot:item.contratto_di_servizio.notes="{ item }">
				<span
					class="d-inline-block text-truncate"
					style="max-width: 150px; cursor: pointer"
					@click="openContrattoDiServizioNotesDialog(item)"
				>
					{{ item.contratto_di_servizio === null ? '' : (item.contratto_di_servizio.notes || '------') }}
				</span>
			</template>

			<template v-slot:item.cliccatore.link_dati_cliccatore="{ item }">
				<span
					v-if="item.cliccatore?.link_dati_cliccatore"
					class="text-no-wrap"
				>
					<v-btn
						icon
						small
						:href="item.cliccatore.link_dati_cliccatore"
						target="_blank"
						title="Apri in una nuova scheda"
					>
						<v-icon small>mdi-open-in-new</v-icon>
					</v-btn>
					<v-btn
						icon
						small
						@click="copiaLinkDatiCliccatore(item.cliccatore.link_dati_cliccatore)"
						title="Copia il link"
					>
						<v-icon small>mdi-content-copy</v-icon>
					</v-btn>
				</span>
			</template>

			<template v-slot:item.tempo_massimo_ammesso="{ item }">
				{{ item.tempo_massimo_ammesso?.replace('.', ',') }}
			</template>

			<template v-slot:item.actions="{ item, index }">
				<!--{{ index }}-->
				<v-hover
					v-if="isAccountManager"
					v-slot="{ hover }"
				>
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openPraticaDialog('edit', item)"
					>
						{{ user?.account_manager?.id !== 4 ? 'mdi-pencil' : 'mdi-test-tube' }}
					</v-icon>
				</v-hover>

				<span :class="`${index == 0 ? 'tour-step-17' : ''}`">
					<v-hover
						v-slot="{ hover }"
					>
						<v-icon
							size="20"
							:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
							@click="tourIsRunning && stepTarget != '.tour-step-17'
								? null
								: openPraticaDialog(!isAccountManager ? 'edit' : 'show', item)
								"
						>
							{{ user?.account_manager?.id !== 4 ? 'mdi-text-box-search-outline' : 'mdi-mushroom' }}
						</v-icon>
					</v-hover>
				</span>

				<v-hover
					v-if="isAccountManager"
					v-slot="{ hover }"
				>
					<v-icon
						:class="`${hover ? 'secondary--text' : ''}`"
						size="20"
						:disabled="item.modifiche_in_coda === null"
						@click="tourIsRunning
							? null
							: openModificheInCodaDialog(item)
							"
					>
						mdi-wrench-clock
					</v-icon>
				</v-hover>

				<v-hover
					v-if="isAccountManager"
					v-slot="{ hover }"
				>
					<v-icon
						:class="`${hover ? 'error--text' : ''}`"
						size="20"
						@click="tourIsRunning
							? null
							: openDeletePraticaDialog(item)
							"
					>
						{{ user?.account_manager?.id !== 4 ? 'mdi-delete-forever' : 'mdi-skull'}}
					</v-icon>
				</v-hover>
			</template>

			<template v-slot:footer.prepend>
				<div class="d-flex align-center">
					<v-btn
						@click="openHideShowHeadersDialog()"
						color="secondary"
						class="ml-md-auto mr-3 white--text"
						depressed
					>
						<template v-if="isCliente">
							Mostra/Nascondi Colonne
						</template>
						<template v-else>
							<v-icon small>mdi-minus</v-icon>
							<v-icon>mdi-view-column-outline</v-icon>
							<v-icon small>mdi-plus</v-icon>
						</template>
					</v-btn>

					<v-btn
						v-if="isAccountManager && user.id == 174"
						color="secondary"
						class="white--text"
						@click="downloadCsvPerElisa()"
						:disabled="isLoadingPratiche"
					>
						Scarica CSV (Per Elisa)
					</v-btn>

					<v-btn
						color="secondary"
						class="white--text"
						@click="downloadCsvColonneVisibili()"
						:disabled="isLoadingPratiche"
					>
						Scarica CSV colonne visibili
					</v-btn>
				</div>
			</template>
		</v-data-table>

		<!-- STORE EDIT VIEW PRATICA -->
		<v-dialog
			:value="praticaDialog"
			persistent
			scrollable
		>
			<store-edit-view-pratica
				:key="storeEditViewPraticaKey"
				v-model="pratica"
				:fasi-with-stati="fasiWithStati"
				:action="action"
				:accordo-id="accordoId"
				:contratto-di-servizio-id="contrattoDiServizioId"
				:active-tab-index="faseIdAnteprimaStatoFasi"
				@close="praticaDialog = false"
				@pratica-updated="updatePraticaObject($event)"
				@reload-pratiche="reloadPratiche($event)"
				@reload-accordi="$emit('reload-accordi')"
				@reload-contratti-di-servizio="$emit('reload-contratti-di-servizio')"
				@aggiornamenti-visualizzati="setAggiornamentiVisualizzati($event)"
				@pratica-notes-updated="updatePraticaNotesInDataTable($event)"
				@accordo-notes-updated="updateAccordoNotesInDataTable($event)"
				@contratto-di-servizio-notes-updated="updateContrattoDiServizioNotesInDataTable($event)"
				@pratica-tags-updated="updatePraticaTagsInDataTable($event)"
				@contratto-di-servizio-tags-updated="updateContrattoDiServizioTagsInDataTable($event)"
			></store-edit-view-pratica>
		</v-dialog>

		<!-- MOSTRA / NASCONDI COLONNE TABELLA -->
		<v-dialog
			v-model="hideShowHeadersDialog"
			width="unset"
		>
			<v-card>
				<v-card-title>
					<span class="mr-1">Mostra/nascondi colonne</span>
					<v-spacer></v-spacer>
					<v-icon @click="hideShowHeadersDialog = false">mdi-close</v-icon>
				</v-card-title>
				<v-card-text>
					<v-sheet
						outlined
						rounded
						class="py-3"
					>
						<v-treeview
							:items="headersToFilter"
							item-key="value"
							item-text="text"
							v-model="selectedHeaders"
							selected-color="primary"
							selectable
							dense
							open-all
						>
						</v-treeview>
					</v-sheet>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- NOTES -->
		<v-dialog
			v-model="praticaNotesDialog"
			persistent
			max-width="700"
			scrollable
		>
			<pratica-notes
				:key="praticaNotesKey"
				v-model="praticaForNotes"
				:show-info-pratica="true"
				@close="praticaNotesDialog = false"
				@pratica-updated="updatePraticaObject($event)"
			></pratica-notes>
		</v-dialog>

		<!-- TAGS PRATICA -->
		<v-dialog
			v-model="tagsDialog"
			persistent
			max-width="700"
			scrollable
		>
			<v-card>
				<v-card-title class="py-2 primary">
					<span class="tertiary--text">Tags Pratica</span>
				</v-card-title>
				<v-card-text>
					<store-edit-delete-pratica-tags
						:key="tagsKey"
						:pratica="praticaForTags"
						@close="tagsDialog = false"
						@tags-updated="updatePraticaTagsInDataTable($event)"
						@is-loading="isLoadingPraticaTags = $event"
					></store-edit-delete-pratica-tags>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						@click="tagsDialog = false"
						:disabled="isLoadingPraticaTags"
						class="black--text"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- DELETE PRATICA -->
		<v-dialog
			:value="deletePraticaDialog"
			persistent
			max-width="600px"
		>
			<v-card>
				<v-card-title class="text-h5">
					Vuoi eliminare la pratica {{ praticaToDelete?.custom_id }}?
				</v-card-title>
				<v-card-text>
					<div>
						<span class="font-weight-medium">Ragione Sociale Pratica: </span>
						<span class="secondary--text">{{ praticaToDelete?.ragione_sociale }}</span>
					</div>
					<div>
						<span class="font-weight-medium">Ragione Sociale Cliente: </span>
						<span class="secondary--text">{{ praticaToDelete?.accordo.cliente.ragione_sociale }}</span>
					</div>
					<div>
						<span class="font-weight-medium">Nome Cliente: </span>
						<span class="secondary--text">{{ praticaToDelete?.accordo.cliente.nome }}</span>
					</div>
					<div>
						<span class="font-weight-medium">Cognome Cliente: </span>
						<span class="secondary--text">{{ praticaToDelete?.accordo.cliente.cognome }}</span>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						@click="deletePraticaDialog = false"
						:disabled="isDeletingPratica"
						class="black--text"
					>
						Annulla
					</v-btn>
					<v-btn
						color="error"
						@click="deletePratica()"
						:loading="isDeletingPratica"
						:disabled="isLoading || isDeletingPratica"
					>
						Elimina
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="filtersDialog"
			scrollable
			persistent
			width="800px"
		>
			<pratiche-filters
				:key="praticheFiltersKey"
				ref="praticheFilters"
				:hide-clienti-filter="accordoId !== null || contrattoDiServizioId !== null"
				@close="filtersDialog = false"
				@reload-pratiche="reloadPratiche()"
			></pratiche-filters>
		</v-dialog>

		<v-dialog
			v-model="accordoNotesDialog"
			persistent
			max-width="700"
			scrollable
		>
			<accordo-notes
				:key="accordoNotesKey"
				v-model="accordoForNotes"
				@close="accordoNotesDialog = false"
				@accordo-updated="updateAccordoNotesInDataTable($event)"
			></accordo-notes>
		</v-dialog>

		<v-dialog
			v-model="contrattoDiServizioNotesDialog"
			persistent
			max-width="700"
			scrollable
		>
			<contratto-di-servizio-notes
				:key="contrattoDiServizioNotesKey"
				v-model="contrattoDiServizioForNotes"
				@close="contrattoDiServizioNotesDialog = false"
				@contratto-di-servizio-updated="updateContrattoDiServizioNotesInDataTable($event)"
			></contratto-di-servizio-notes>
		</v-dialog>

		<!-- TAGS -->
		<v-dialog
			v-model="contrattoDiServizioTagsDialog"
			persistent
			max-width="700"
			scrollable
		>
			<v-card>
				<v-card-title class="py-2 primary">
					<span class="tertiary--text">Tags Contratto di Servizio</span>
				</v-card-title>
				<v-card-text>
					<store-edit-delete-contratto-di-servizio-tags
						:key="contrattoDiServizioTagsKey"
						:contratto-di-servizio="contrattoDiServizioForTags"
						@is-loading="isLoadingContrattoDiServizioTags = $event"
						@close="contrattoDiServizioTagsDialog = false"
						@tags-updated="updateContrattoDiServizioTagsInDataTable($event)"
					></store-edit-delete-contratto-di-servizio-tags>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						@click="contrattoDiServizioTagsDialog = false"
						:disabled="isLoadingContrattoDiServizioTags"
						class="black--text"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="modificheInCodaDialog"
			persistent
			width="unset"
			scrollable
		>
			<modifiche-in-coda
				v-model="praticaPerModificheInCoda"
				:key="modificheInCodaDialogKey"
				@close="modificheInCodaDialog = false;"
				@email-inviata="reloadPratiche()"
			></modifiche-in-coda>
		</v-dialog>

	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import { eventBus } from "@/event-bus";
import PraticaNotes from "./PraticaNotes.vue";
export default {
	components: {PraticaNotes},
	props: [
		'search',
		// 'fasiWithStati',
		'accordoId', // quando nella pagina Accordi si apre il v-dialog con le pratiche di quell'accordo
		'contrattoDiServizioId', // quando nella pagina Contratti di servizio si apre il v-dialog con le pratiche di quel contratto
		// 'accountManagersIds'
	],
	data() {
		return {
			isLoadingPratiche: false,
			isReloadingPratiche: false,
			pratiche: [],

			praticheFiltersKey: 0,
			filtersDialog: false,

			hideShowHeadersDialog: false,
			selectedHeaders: [],

			updatingPraticaObject: false,

			// store edit view pratica
			storeEditViewPraticaKey: 0,
			praticaDialog: false,
			pratica: null,
			action: null,

			// notes
			praticaNotesKey: 0,
			praticaNotesDialog: false,
			praticaForNotes: null,

			// tags pratica
			tagsKey: 0,
			praticaForTags: false,
			tagsDialog: null,
			isLoadingPraticaTags: false,
			updatingPraticaTags: false,

			// tags contratto di servizio
			contrattoDiServizioTagsKey: 0,
			contrattoDiServizioTagsDialog: false,
			contrattoDiServizioForTags: null,
			isLoadingContrattoDiServizioTags: false,
			updatingContrattoDiServizioTags: false,

			// delete pratica
			deletePraticaDialog: false,
			praticaToDelete: null,
			isDeletingPratica: false,

			accordoNotesKey: 0,
			accordoForNotes: null,
			accordoNotesDialog: false,

			contrattoDiServizioNotesKey: 0,
			contrattoDiServizioForNotes: null,
			contrattoDiServizioNotesDialog: false,

			modificheInCodaDialogKey: 0,
			modificheInCodaDialog: false,
			praticaPerModificheInCoda: null,

			faseIdAnteprimaStatoFasi: null
		}
	},

	async created() {
		if (this.tourIsRunning) this.setShowStep(false); // nascondo lo step in attesa del caricamento delle pratiche

		this.getPratiche();

		// if (this.isAccountManager) {
		// 	this.getPratiche();
		// }
		// else {
		// 	this.getPratiche();
		// }

		// NON CANCELLARE, evento usato dalla guida (vue-tour)
		// salvo la callback in una proprietà così da poterla rimuovere nel beforeDestroy
		this._onClosePraticaDialog = () => { this.praticaDialog = false };
		eventBus.$on('close-pratica-dialog', this._onClosePraticaDialog);
		// eventBus.$on('close-pratica-dialog', () => {
		// 	this.praticaDialog = false;
		// });

		// recupero dal localStorage le colonne che si è scelto di mostrare nella tabella

		if (localStorage.getItem('selected_pratiche_headers_manager_clickday')) {
			this.selectedHeaders = JSON.parse(localStorage.getItem('selected_pratiche_headers_manager_clickday'));
		}
		else {
			this.selectedHeaders = this.headers.map(header => (header.value));
			localStorage.setItem('selected_pratiche_headers_manager_clickday', JSON.stringify(this.selectedHeaders));
		}

	},

	beforeDestroy () {
		eventBus.$off('close-pratica-dialog', this._onClosePraticaDialog);
	},

	watch: {
		isLoading(isLoading) {
			if (!isLoading) {
				if (this.tourIsRunning && this.isCliente) {
					this.$tours['guida'].nextStep();
					this.setShowStep(true);
				}
			}
		},
		selectedHeaders(newHeaders, oldHeaders) {
			localStorage.setItem('selected_pratiche_headers_manager_clickday', JSON.stringify(newHeaders));
		}
	},

	computed: {
		...mapGetters({
			user: 'auth/user',
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
			fasiWithStati: 'fasi/fasiWithStati',
			statiColorMap: 'fasi/statiColorMap',
			fasiDelBandoAttivo: 'fasi/fasiDelBandoAttivo',
			isLoadingStatiWithFasi: 'fasi/isLoading',
			tourIsRunning: 'tour/isRunning',
			clientiIdsFilter: 'praticheFilters/clientiIds',
			// tagsIdsFilter: 'praticheFilters/tagsIds',
			esitoClickDayFilter: 'praticheFilters/esitoClickDay',
			appliedFilters: 'praticheFilters/appliedFilters',
			accountManagersIds: 'sharedFilters/accountManagersIds'
		}),
		computedAccountManagersIds() {
			return this.accountManagersIds.value;
		},
		stepTarget() {
			if (this.tourIsRunning) return this.$tours['guida'].step.target;
			else return null
		},
		isLoading() {
			return this.isLoadingStatiWithFasi
				|| this.isLoadingPratiche;
		},
		headers() {
			return [
				{ // Visibile solo agli Account Managers
					text: 'Tipologia Cliente',
					value: 'accordo.cliente.tipologia',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{ // Visibile solo agli Account Managers
					text: 'Codice Cliente',
					value: 'accordo.cliente.codice_cliente',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{ // Visibile solo agli Account Managers
					text: 'Ragione Sociale Cliente',
					value: 'accordo.cliente.ragione_sociale',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{ // Visibile solo agli Account Managers
					text: 'Nome Cliente',
					value: 'accordo.cliente.nome',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{ // Visibile solo agli Account Managers
					text: 'Cognome Cliente',
					value: 'accordo.cliente.cognome',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{ // Visibile solo agli Account Managers
					text: 'Email Cliente',
					value: 'accordo.cliente.email',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Nome Referente',
					value: 'accordo.nome_referente',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Cognome Referente',
					value: 'accordo.cognome_referente',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Email Referente',
					value: 'accordo.email_referente',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'ID Pratica',
					value: 'custom_id',
					class: `tour-step-10 tour-step-11
						${this.stepTarget == '.tour-step-10' || this.stepTarget == '.tour-step-11'
							? 'v-tour__target--highlighted--inset'
							: ''
						}`
				},
				{
					text: 'Ragione Sociale Pratica',
					value: 'ragione_sociale',
					class: `tour-step-12 ${this.stepTarget == '.tour-step-12'
						? 'v-tour__target--highlighted--inset'
						: ''
					}`
				},
        {
					text: 'Partita IVA / Codice Fiscale Pratica',
					value: 'partita_iva_codice_fiscale',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
        {
					text: 'Partita IVA / Codice Fiscale Univoco',
					value: 'partita_iva_codice_fiscale_univoco',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
        {
					text: 'Codice Identificativo',
					value: 'codice_identificativo',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Imponibile da Fatturare Esiti Provvisori',
					value: 'importo_da_fatturare',
					class: (this.isAccountManager || this.isCliente) || 'd-none',
					cellClass: (this.isAccountManager || this.isCliente) || 'd-none',
				},
				{
					text: 'Imponibile Bonus Esiti Provvisori',
					value: 'importo_bonus_esiti_provvisori',
					class: (this.isAccountManager || this.isCliente) || 'd-none',
					cellClass: (this.isAccountManager || this.isCliente) || 'd-none',
				},
				{
					text: 'Imponibile da Fatturare Esiti Definitivi',
					value: 'importo_da_fatturare_esiti_definitivi',
					class: (this.isAccountManager || this.isCliente) || 'd-none',
					cellClass: (this.isAccountManager || this.isCliente) || 'd-none',
				},
				{
					text: 'Imponibile Bonus Esiti Definitivi',
					value: 'importo_bonus_esiti_definitivi',
					class: (this.isAccountManager || this.isCliente) || 'd-none',
					cellClass: (this.isAccountManager || this.isCliente) || 'd-none',
				},
				{
					text: 'Modalità di Pagamento',
					value: 'contratto_di_servizio.tipo_contratto_di_servizio.tipo_pagamento',
					class: (this.isAccountManager || this.isCliente) || 'd-none',
					cellClass: (this.isAccountManager || this.isCliente) || 'd-none',
				},
				{
					text: 'Modalità di Erogazione Bonus',
					value: 'contratto_di_servizio.tipo_erogazione_bonus',
					class: (this.isAccountManager) || 'd-none',
					cellClass: (this.isAccountManager) || 'd-none',
				},
				{
					text: 'PEC Abilitata',
					value: 'is_pec_abilitata_text',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Regione',
					value: 'regione',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Asse di Finanziamento',
					value: 'asse_di_finanziamento.nome',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Tempo Massimo Ammesso',
					value: 'tempo_massimo_ammesso',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Importo Agevolazione',
					value: 'agevolazione_richiesta_senza_casting',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				// {
				// 	text: 'Denominazione Pratica',
				// 	value: 'denominazione',
				// 	class: `${this.stepTarget == '.tour-step-12'
				// 		? 'v-tour__target--highlighted--inset v-tour__target--relative'
				// 		: ''
				// 	}`
				// },
				// {
				// 	text: 'Importo',
				// 	value: 'agevolazione_richiesta',
				// 	class: `${this.stepTarget == '.tour-step-12'
				// 		? 'v-tour__target--highlighted--inset v-tour__target--relative'
				// 		: ''
				// 	}`
				// },
				{
					text: 'Priorità',
					value: 'priorita',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Account Manager',
					value: 'accordo.account_manager.nome_cognome_account_manager',
					// class: this.isCliente || 'd-none',
					// cellClass: this.isCliente || 'd-none',
				},
				{
					text: 'Stato Fasi Pratica',
					value: 'stato_fasi_pratica',
					width: '210px',
					sortable: false,
					filterable: false
					// class: 'tour-step-13 tour-step-14'
				},
				{ // Visibile solo agli Account Managers
					text: 'Esito',
					value: 'esito_clickday',
					filterable: false
				},
				{ // Visibile solo agli Account Managers
					text: 'Esito Manuale Pratica',
					value: 'esito_clickday_manuale',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
					filterable: false
				},
				{ // Visibile solo agli Account Managers
					text: 'Tempo Click Day',
					value: 'tempo_clickday'
				},
				{
					text: 'Codice Cliccatore',
					value: 'cliccatore.codice_cliccatore',
					class: (this.isAccountManager || this.isCliente) || 'd-none',
					cellClass: (this.isAccountManager || this.isCliente) || 'd-none',
				},
				{
					text: 'Link Cliccatore',
					value: 'cliccatore.link_dati_cliccatore',
					sortable: false,
					filterable: false,
					class: (this.isAccountManager || this.isCliente) || 'd-none',
					cellClass: (this.isAccountManager || this.isCliente) || 'd-none',
				},
				{
					text: 'Nome Cliccatore',
					value: 'cliccatore.nome',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Cognome Cliccatore',
					value: 'cliccatore.cognome',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Posizione Classifica (Percentili)',
					value: 'posizione_classifica_a_tempo',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Codice Univoco di Preconvalida',
					value: 'codice_univoco_di_preconvalida',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{ // Visibile solo agli Account Managers
					text: 'Coordinatore',
					value: 'cliccatore.team.team_leader.username',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{ // Visibile solo agli Account Managers
					text: 'Tags Pratica',
					value: 'one_string_tags',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
					filterable: false
				},
				{ // Visibile solo agli Account Managers
					text: 'Tags Contratto di Servizio',
					value: 'contratto_di_servizio.one_string_tags',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
					filterable: false
				},
				{ // Visibile solo agli Account Managers
					text: 'Note Pratica',
					value: 'notes',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{ // Visibile solo agli Account Managers
					text: 'Note Accordo',
					value: 'accordo.notes',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{ // Visibile solo agli Account Managers
					text: 'Note Contratto di Servizio',
					value: 'contratto_di_servizio.notes',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none',
				},
				{
					text: 'Data Inserimento',
					value: 'created_at',
					width: '120px',
					filterable: false,
					class: `tour-step-15 ${this.stepTarget == '.tour-step-15'
						? 'v-tour__target--highlighted--inset v-tour__target--relative'
						: ''
					}`
				},
				{
					text: 'Data Ora Ultimo Aggiornamento',
					value: 'updated_at',
					width: '140px',
					filterable: false,
					class: `tour-step-16 ${this.stepTarget == '.tour-step-16'
						? 'v-tour__target--highlighted--inset v-tour__target--relative'
						: ''
					}`
				},
				{
					text: 'Azioni',
					value: 'actions',
					width: '140px',
					sortable: false,
					filterable: false
				},
			]
		},
		headersToFilter() {
			let headers = this.isCliente ? this.headers.filter(h => h.class != 'd-none') : this.headers;

			return [{
				value: 'headers',
				text: 'Tutte',
				children: headers.flatMap(header => {
					if (header.value !== 'actions') {
						return {
							value: header.value,
							text: header.text
						}
					}
					else return [];
				})
			}]
		},
		headersToShow() {
			return this.headers.filter(header => this.selectedHeaders.includes(header.value) || header.value == 'actions')
		},
		dataTableHeight() {
			// quando nella pagina Accordi si apre il v-dialog con le pratiche di quell'accordo
			if (this.accordoId || this.contrattoDiServizioId) return 'calc(100vh - 350px)';
			else return 'calc(100vh - 207px)'
		},
    /**
     * Filtro le pratiche in base al testo inserito nella barra di ricerca presente in Pratiche.vue.
     * Mi serve questa computed da usare in Pratiche.vue nel method openAssegnazioneCliccatoriInMassaDialog perchè
     * voglio che le pratiche che vengono passate al componente assegnazione-cliccatori-in-massa per l'assegnazione
     * in massa siano filtrate in base al testo di ricerca
     */
		praticheFiltrate() {
			if (!this.search) return this.pratiche;

			const testoDiRicercaNormalizzato = this.search.toLocaleLowerCase();
			const percorsiCampiRicercabili = this.headers
				.filter(h => h.filterable !== false)
				.map(h => h.value);

			return this.pratiche.filter(pratica =>
				percorsiCampiRicercabili.some(percorso => {
					const valore = this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, percorso);
					return valore != null
						&& typeof valore !== 'boolean'
						&& valore.toString().toLocaleLowerCase().includes(testoDiRicercaNormalizzato);
				})
			);
		}
	},

	methods: {
		...mapMutations({
			setShowStep: 'tour/SET_SHOW_STEP',
		}),
		...mapActions({
			showSnackbar: 'systemSnackbar/show'
		}),
		getPratiche() {
			this.isLoadingPratiche = true;
			this.$emit('is-loading', true);
			return axios.get('/api/pratiche', {
				params: {
					accordo_id: this.accordoId, // quando nella pagina Accordi si apre il v-dialog con le pratiche di quell'accordo
					contratto_di_servizio_id: this.contrattoDiServizioId, // quando nella pagina Contratti di servizio si apre il v-dialog con le pratiche di quel contratto
					// clientiIds: this.clientiIdsFilter, // filtro per clienti.
					// idsStatiFasi: this.filters.idsStatiFasi,
					// tagsIds: this.tagsIdsFilter,
					// esitoClickDay: this.esitoClickDayFilter,
					filters: this.appliedFilters,
					accountManagersIds: this.computedAccountManagersIds
				}
			})
				.then(response => {
					this.pratiche = response.data;

					// const now = Date.now() // timestamp base
					// this.pratiche = response.data.map(pratica => ({
					// 	...pratica,
					// 	// ad ogni pratica do una chiave univoca che mi serve per renderizzare nuovamente i componenti quando avviene un aggiornamento
					// 	virtualUniqueKey: `${now}-${pratica.id}`
					// }))
				})
				.finally(() => {
					this.isLoadingPratiche = false;
					this.$emit('is-loading', false);
				})
		},
		async reloadPratiche(event = null) {
			this.isReloadingPratiche = true;
			// if (this.accordoId) this.$emit('reload-accordi');
			await this.getPratiche();
			this.isReloadingPratiche = false;
		},
		openHideShowHeadersDialog() {
			this.hideShowHeadersDialog = true;
		},
		openPraticaDialog(action, pratica = null, faseId = null) {
			this.pratica = pratica;
			this.action = action;
			/**
			 * faseId è diverso da null quando si vuole usare il componente anteprima-stato-fasi, altrimenti sarà null;
			 * serve al componente store-edit-view-pratica per aprire direttamente la tab della fase desiderata
			 */
			this.faseIdAnteprimaStatoFasi = faseId;
			this.storeEditViewPraticaKey++;
			this.praticaDialog = true;
		},
		openPraticaNotesDialog(pratica) {
			this.praticaNotesKey++;
			this.praticaForNotes = pratica;
			this.praticaNotesDialog = true;
		},
		openAccordoNotesDialog(pratica) {
			this.accordoNotesKey++;
			this.accordoForNotes = pratica.accordo;
			this.accordoNotesDialog = true;
		},
		openContrattoDiServizioNotesDialog(pratica) {
			this.contrattoDiServizioNotesKey++;
			this.contrattoDiServizioForNotes = pratica.contratto_di_servizio;
			this.contrattoDiServizioNotesDialog = true;
		},
		updatePraticaNotesInDataTable(data) {
			let pratica = this.pratiche?.find(pratica => pratica.id == data.praticaId);
			pratica.notes = data.praticaNotesUpdated;
		},
		updateAccordoNotesInDataTable(data) {
			let pratiche = this.pratiche?.filter(pratica => pratica.accordo.id == data.accordoUpdated.id);
			pratiche.forEach(pratica => {
				pratica.accordo.notes = data.accordoUpdated.notes;
			})
		},
		updateContrattoDiServizioNotesInDataTable(data) {
			let pratiche = this.pratiche?.filter(pratica => pratica.contratto_di_servizio_id == data.contrattoDiServizioUpdated.id);
			pratiche.forEach(pratica => {
				pratica.contratto_di_servizio.notes = data.contrattoDiServizioUpdated.notes;
			})
		},
		openTagsDialog(pratica) {
			this.tagsKey++;
			this.praticaForTags = pratica;
			this.tagsDialog = true;
		},
		openContrattoDiServizioTagsDialog(contrattoDiServizio) {
			this.contrattoDiServizioTagsKey++;
			this.contrattoDiServizioForTags = contrattoDiServizio;
			this.contrattoDiServizioTagsDialog = true;
		},
		updatePraticaObject(data) {
			const praticaAggiornata = data.praticaAggiornata;

			const callAxios = data.callAxios;
			const praticaId = data.praticaId; // presente solo insieme a callAxios perchè in questo caso mi serve solo l'id per ottenerla dal backend

			this.updatingPraticaObject = true;

			const now = Date.now() // timestamp base

			if (callAxios) {
				// TODO: probabile bug non indagato: bisogna passare come parametro accountManagersIds: this.computedAccountManagersIds quando si è filtrato per AM escludendo l'AM loggato
				axios.get(`/api/pratiche/${praticaId}`, {
					params: {
						accountManagersIds: this.computedAccountManagersIds
					}
				})
					.then(response => {
						const indexPraticaDaAggiornare = this.pratiche.findIndex(p => p.id === praticaId);

						this.$set(this.pratiche, indexPraticaDaAggiornare, response.data);
						// this.$set(
						// 	this.pratiche,
						// 	indexPraticaDaAggiornare,
						// 	{
						// 		...response.data,
						// 		virtualUniqueKey: `${now}-${praticaId}`
						// 	}
						// );

						this.updatingPraticaObject = false;
					})
			}
			else {
				const indexPraticaDaAggiornare = this.pratiche.findIndex(p => p.id === praticaAggiornata.id);

				this.$set(this.pratiche, indexPraticaDaAggiornare, praticaAggiornata);
				// this.$set(
				// 	this.pratiche,
				// 	indexPraticaDaAggiornare,
				// 	{
				// 		...praticaAggiornata,
				// 		virtualUniqueKey: `${now}-${praticaAggiornata.id}`
				// 	}
				// );

				this.updatingPraticaObject = false;
			}


		},
		openDeletePraticaDialog(pratica) {
			this.praticaToDelete = pratica;
			this.deletePraticaDialog = true;
		},
		deletePratica() {
			this.isDeletingPratica = true;
			axios.delete(`/api/pratiche/${this.praticaToDelete.id}`)
				.then(response => {
					this.deletePraticaDialog = false;
					this.deletePraticaFromDataObject(this.praticaToDelete.id);
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
				})
				.finally(() => {
					this.isDeletingPratica = false;
				})
		},
		deletePraticaFromDataObject(id) {
			this.$delete(this.pratiche, this.pratiche.findIndex((pratica) => pratica.id == id));
		},
		openPraticheFilters() {
			this.filtersDialog = true;
		},
		setAggiornamentiVisualizzati(data) {
			this.pratiche.find(p => p.id == data.praticaId)[data.aggiornamentoKey] = data.aggiornamentoValue;
		},
		downloadCsvPerElisa() {
			let pratichePerCsv = this.pratiche.map(item => {
				return {
					ragione_sociale_pratica: item.ragione_sociale,
					ragione_sociale_contratto: item.contratto_di_servizio?.ragione_sociale,
					importo_acconto_contratto: item.contratto_di_servizio?.importo_acconto,
					importo_saldo_contratto: item.contratto_di_servizio?.importo_saldo,
					importo_da_fatturare_esiti_provvisori_pratica: item.importo_da_fatturare,
					importo_da_fatturare_esiti_definitivi_pratica: item.importo_da_fatturare_esiti_definitivi,
					stato_fase_9: this.fasiWithStati.find(fase => fase.id == 9)?.stati?.find(stato => stato.id == item.id_stato_fase_9).nome
				}
			})

			let csv = this.$papa.unparse(pratichePerCsv, {
				delimiter: ";",
				header: true,
				columns: [
					'ragione_sociale_pratica',
					'ragione_sociale_contratto',
					'importo_acconto_contratto',
					'importo_saldo_contratto',
					'importo_da_fatturare_esiti_provvisori_pratica',
					'importo_da_fatturare_esiti_definitivi_pratica',
					'stato_fase_9'
				]
			});

			// Prepend BOM (risolve problemi di codifica)
			csv = '\uFEFF' + csv;

			this.$papa.download(csv, 'pratiche')
		},
		downloadCsvColonneVisibili() {
			// 1. Header realmente mostrati in tabella, escluse colonne da ignorare
			const headersCsv = this.headersToShow
				.filter(header => header.value !== 'actions' && header.value !== 'stato_fasi_pratica'); // aggiungi altri value da escludere se servono

			// 2. Trasformo ogni riga della tabella in un oggetto pronto per il CSV
			const rows = this.pratiche.map(pratica => {
				const row = {};
				headersCsv.forEach(header => {
					if (header.value === 'updated_at') row[header.text] = this.formatDateTimeToItaly(this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value));
					else if (header.value === 'created_at') row[header.text] = this.getDateFromDateTime(this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value));

					// sostituisco il punto con la virgola per i valori numerici in formato stringa
					else if (header.value === 'agevolazione_richiesta_senza_casting') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value)?.replace('.', ',');
					else if (header.value === 'importo_da_fatturare') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value)?.replace('.', ',');
					else if (header.value === 'importo_bonus_esiti_provvisori') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value)?.replace('.', ',');
					else if (header.value === 'importo_da_fatturare_esiti_definitivi') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value)?.replace('.', ',');
					else if (header.value === 'importo_bonus_esiti_definitivi') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value)?.replace('.', ',');
					else if (header.value === 'tempo_massimo_ammesso') row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value)?.replace('.', ',');

					else row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(pratica, header.value);  // la chiave è il label visibile, non il path

				});
				return row;
			});

			// 3. Creo il CSV
			let csv = this.$papa.unparse(rows, {
				delimiter: ';',
				header: true,
				columns: headersCsv.map(header => header.text) // ordine colonne = ordine header corrente
			});

			// Prepend BOM (risolve problemi di codifica)
			csv = '\uFEFF' + csv;

			// 4. Download
			this.$papa.download(csv, 'pratiche');
		},
		updateContrattoDiServizioTagsInDataTable(data) {
			this.updatingContrattoDiServizioTags = true;

			axios.get(`/api/contratti-di-servizio/${data.contrattoDiServizio.id}`)
				.then(response => {
					let pratiche = this.pratiche?.filter(pratica => pratica.contratto_di_servizio_id == data.contrattoDiServizio.id);
					pratiche.forEach(pratica => {
						pratica.contratto_di_servizio.one_string_tags = response.data.one_string_tags;
					})
				})
				.finally(() => {
					this.updatingContrattoDiServizioTags = false;
				})
		},
		updatePraticaTagsInDataTable(data) {
			this.updatingPraticaTags = true;

			axios.get(`/api/pratiche/${data.pratica.id}`, {
				params: {
					accountManagersIds: this.computedAccountManagersIds
				}
			})
				.then(response => {
					let pratica = this.pratiche?.find(pratica => pratica.id == data.pratica.id);
					pratica.one_string_tags = response.data.one_string_tags;
				})
				.finally(() => {
					this.updatingPraticaTags = false;
				})
		},
		openModificheInCodaDialog(pratica) {
			this.praticaPerModificheInCoda = pratica;
			this.modificheInCodaDialogKey++;
			this.modificheInCodaDialog = true;
		},
		calcolaAggiornamentiAnteprimaStatoFasiPratica(pratica) {
			// console.log('calcolaAggiornamenti')

			return Object.keys(pratica)
				.filter(key =>
					key.startsWith('ci_sono_aggiornamenti_fase') &&
					this.fasiDelBandoAttivo.has(+key.slice(-1)) // lookup O(1)
				)
				.reduce((out, key) => {
					const faseN = +key.slice(-1)
					const statoId = pratica[`id_stato_fase_${faseN}`]
					out[key] = {
						ci_sono_aggiornamenti_fase: pratica[key],
						colore_dello_stato: this.statiColorMap[statoId] || ''
					}
					return out
				}, Object.create(null)) // risultato minimale
		}
	}
}
</script>

<style scoped>

</style>
